import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";

interface ITitleProps {
  title?: string;
  className?: string;
}

const useStyles = makeStyles(() => ({
  titleStyle: {
    textAlign: "center",
    marginBottom: 12
  },
}));

export const Title: React.FC<ITitleProps> = (props: ITitleProps) => {
  const css = useStyles(props);

  return (
    <div className={clsx(css.titleStyle, props.className)}>
      <Typography variant='h2'>{props.title}</Typography>
    </div>
  );
};

export default Title;
